// Landing Page KPI Highlights - Only 5 main KPIs
export const landingKpisData = {
  2024: {
    productionVsPlan: { value: 88, unit: "%", vsBudget: -12, vsPrevious: null, status: "attention", category: "operations" },
    revenue: { value: 245, unit: "M USD", vsBudget: -5, vsPrevious: null, status: "inline", category: "finance" },
    ebitda: { value: 78, unit: "M USD", vsBudget: -3, vsPrevious: null, status: "inline", category: "finance" },
    cashAvailable: { value: 42, unit: "M USD", vsBudget: -15, vsPrevious: null, status: "attention", category: "finance" },
    capexVsBudget: { value: 76, unit: "%", vsBudget: -24, vsPrevious: null, status: "pressure", category: "finance" },
  },
  2025: {
    productionVsPlan: { value: 94, unit: "%", vsBudget: -6, vsPrevious: 6, status: "attention", category: "operations" },
    revenue: { value: 298, unit: "M USD", vsBudget: 3, vsPrevious: 21.6, status: "strong", category: "finance" },
    ebitda: { value: 102, unit: "M USD", vsBudget: 8, vsPrevious: 30.8, status: "strong", category: "finance" },
    cashAvailable: { value: 56, unit: "M USD", vsBudget: 5, vsPrevious: 33.3, status: "strong", category: "finance" },
    capexVsBudget: { value: 87, unit: "%", vsBudget: -13, vsPrevious: 11, status: "attention", category: "finance" },
  },
  2026: {
    productionVsPlan: { value: 92, unit: "%", vsBudget: -8, vsPrevious: -2, status: "attention", category: "operations" },
    revenue: { value: 250, unit: "M USD", vsBudget: 4.2, vsPrevious: 2.0, status: "strong", category: "finance" },
    ebitda: { value: 118, unit: "M USD", vsBudget: 12, vsPrevious: 15.7, status: "strong", category: "finance" },
    cashAvailable: { value: 48, unit: "M USD", vsBudget: -8, vsPrevious: -14.3, status: "attention", category: "finance" },
    capexVsBudget: { value: 82, unit: "%", vsBudget: -18, vsPrevious: -5, status: "attention", category: "finance" },
  },
};
